import React from 'react'
import type { Listing, Maybe } from '@adc/sdk/types'
import {
  AuctionInfo,
  PropertyInfo,
  CardImage,
} from '../../../listing/popupCard/cardParts'
import Icon from '../../../elementals/icon'
import { formatListingImgUrl } from '../../../listing/utils/formatters'
import { getListingImageUrl } from '../../../../utils/listing'
import classnames from 'classnames/bind'
import cls from './styles.scss'
const cx = classnames.bind(cls)

const LISTING_CARD_PHOTO_WIDTH = 110

const getListingPhotoUrl = (listingPrimaryPhoto: string, multiplier = 1) =>
  formatListingImgUrl(listingPrimaryPhoto, {
    width: LISTING_CARD_PHOTO_WIDTH * multiplier,
  }) as string

interface IAddressProps {
  address: Maybe<string[]>
  elmId: string
}
const Address = ({ address, elmId }: IAddressProps) => {
  return (
    <div className={cx('address-container', 'nowrap')}>
      <div
        data-elm-id={`${elmId}_address_field_1`}
        className={cx('address-field', 'address-field-1', 'nowrap')}
      >
        {address?.[0]}
      </div>
      <div
        data-elm-id={`${elmId}_address_field_2`}
        className={cx('address-field', 'nowrap')}
      >
        {address?.[1]}
      </div>
    </div>
  )
}

interface IListingItemProps {
  listing: Maybe<Partial<Listing>>
  elmId: string
  className?: string
  onClose?: () => void
  viewMode?: boolean
}

const ListingItem = ({
  listing,
  elmId,
  className,
  onClose,
  viewMode = false,
}: IListingItemProps) => {
  if (!listing) return null
  const listingPhotoUrl = getListingPhotoUrl(listing?.primary_photo || '', 2)
  const defaultPhotoUrl = getListingImageUrl() as string
  return (
    <div data-elm-id={elmId} className={cx('listing-item', className)}>
      {onClose && !viewMode && (
        <Icon
          className={cx('close-icon')}
          name='xmark'
          iconStyle='regular'
          onClick={onClose}
          size='medium'
        />
      )}
      <CardImage
        // @ts-ignore next line
        listing={listing}
        listingPhotoUrl={listingPhotoUrl}
        defaultPhotoUrl={defaultPhotoUrl}
      />
      {listing?.is_searchable && listing?.is_published && (
        <Icon
          className={cx('published-icon')}
          name='globe'
          iconStyle='solid'
          size='large'
          color='adcLightGreen'
        />
      )}
      <div className={cx('info-section')}>
        {/* @ts-ignore next line */}
        <Address elmId={elmId} address={listing.formatted_address || []} />
        <PropertyInfo
          listing={listing as Listing}
          className={cx('property-info')}
        />

        {listing?.listing_configuration?.product_type && (
          // @ts-ignore next line
          <AuctionInfo listing={listing} hideAuctionType hideAuctionDate />
        )}
        <div className={cx('listing-id')}>
          Listing ID: <b>{listing.listing_id}</b>
        </div>
      </div>
    </div>
  )
}

export default ListingItem
